/**
 * Factory file for project history related data.
 *
 * @exports projectComments
 * @category Factories
 */

const broker = {
  name: 'Russell Brokerage',
};
const brokerUserOne = {
  first_name: 'Michael',
  last_name: 'Bishop',
  broker,
};
const brokerUserTwo = {
  first_name: 'Marsha',
  last_name: 'Barnett',
  broker,
};
const carrier = {
  name: 'Business Business Insurance Carrier Co',
};
const carrierUserOne = {
  first_name: 'Ricki',
  last_name: 'Metzger',
  carrier,
  broker: {},
};
const carrierUserTwo = {
  first_name: 'Sean',
  last_name: 'Perkins',
  carrier,
  broker: {},
};

export default {
  /**
   * Get a projectHistoryComment
   *
   * @param {object} initialData
   * @returns {object}
   */
  getProjectComment(initialData = {}) {
    return {
      content: 'This is a comment.',
      commentable_id: 5091,
      commentable_type: 'Document',
      created_at: '2019-10-25T12:01:48.854217',
      is_new: false,
      id: 1,
      parent_id: null,
      user: {
        first_name: 'Johnny',
        last_name: 'Appleseed',
      },
      ...initialData,
    };
  },

  /**
   * Get a single comment
   *
   * @param {object} initialData
   * @returns {object}
   */
  getSingleProjectComment(initialData = {}) {
    return this.getProjectComment({
      content: 'My # of ees for PADD includes from the form fire census the tab ABC and Leviticus.',
      user: carrierUserOne,
      ...initialData,
    });
  },

  /**
   * Get projectHistory info based on parameters.
   *
   * @returns {object}
   */
  getProjectComments() {
    const comments = [
      this.getProjectComment({
        content: 'My # of ees for PADD includes from the form fire census the tab ABC and Leviticus.',
        id: 100,
        is_new: true,
        user: carrierUserOne,
      }),

      this.getProjectComment({
        content: 'This is a clever answer!',
        created_at: '2019-10-21T12:00:48.854217',
        id: 200,
        showSuccess: true,
        user: brokerUserOne,
      }),

      this.getProjectComment({
        content: 'Hi, the due date for submissions was 10/11. I will be pulling the quotes I have soon to be presented to ABC. If you wish to be included please get your proposals in as soon as possible.',
        id: 300,
        created_at: '2019-12-01T12:01:48.854217',
        user: brokerUserTwo,
      }),

      this.getProjectComment({
        content: 'Hi friend - Checking in on the occupation census. Any update on that?',
        created_at: '2019-12-01T11:57:48.854217',
        id: 400,
        user: carrierUserTwo,
        replies: [
          this.getProjectComment({
            content: 'Hey pal,\n\nI have sent you an email with the census with the occupations we could get.',
            created_at: '2019-12-01T12:10:48.854217',
            id: 401,
            is_new: true,
            user: brokerUserOne,
          }),
          this.getProjectComment({
            content: 'Another line, because we can.',
            created_at: '2019-12-01T12:07:48.854217',
            id: 402,
            user: brokerUserTwo,
          }),
        ],
      }),

      /* eslint-disable max-len */
      this.getProjectComment({
        content:
          `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vitae mi eget sapien malesuada placerat vitae vitae metus. Aenean vel nulla dignissim, efficitur neque non, placerat velit. In fringilla mauris sit amet ante pretium, eu molestie tortor finibus. Morbi at hendrerit est. Nam quis rutrum purus. Donec in congue nisi, vel malesuada nibh. Fusce ultrices feugiat ante.

          Here's an example of a "list"
          - thing one
          - thing two

          Vestibulum faucibus quam id lectus egestas vehicula. Sed porttitor, enim ut ultricies laoreet, diam eros dignissim leo, vitae elementum sapien lectus nec elit. Mauris vel felis vulputate, scelerisque nulla nec, commodo purus. Ut sed mauris sit amet massa placerat eleifend aliquam volutpat nunc. Cras a tincidunt tortor. Integer ullamcorper quis est in porta. Sed ut semper sapien, a aliquam mi. Ut dictum dignissim risus, ut tincidunt quam aliquam id.

          Curabitur et tristique eros. Suspendisse vulputate turpis quam, in gravida nunc varius quis. Proin imperdiet leo eget tellus sagittis, sit amet hendrerit ligula tempus. Curabitur ipsum lectus, tempus sed urna eu, accumsan finibus neque. Suspendisse aliquam eu lectus sed facilisis. Fusce faucibus, sem nec posuere tempus, sapien magna finibus lacus, non venenatis nibh ex tristique ante. Cras sed interdum est, et lobortis enim. Nulla gravida metus id quam rhoncus iaculis. Donec sit amet sodales tellus. Aenean et mauris sapien.

          Good day, buddy - Have you been able to obtain an updated census with the Leviticus occupations?  Has the due date been extended on this RFP?

          Vestibulum faucibus quam id lectus egestas vehicula. Sed porttitor, enim ut ultricies laoreet, diam eros dignissim leo, vitae elementum sapien lectus nec elit. Mauris vel felis vulputate, scelerisque nulla nec, commodo purus. Ut sed mauris sit amet massa placerat eleifend aliquam volutpat nunc. Cras a tincidunt tortor. Integer ullamcorper quis est in porta. Sed ut semper sapien, a aliquam mi. Ut dictum dignissim risus, ut tincidunt quam aliquam id.

          Curabitur et tristique eros. Suspendisse vulputate turpis quam, in gravida nunc varius quis. Proin imperdiet leo eget tellus sagittis, sit amet hendrerit ligula tempus. Curabitur ipsum lectus, tempus sed urna eu, accumsan finibus neque. Suspendisse aliquam eu lectus sed facilisis. Fusce faucibus, sem nec posuere tempus, sapien magna finibus lacus, non venenatis nibh ex tristique ante. Cras sed interdum est, et lobortis enim. Nulla gravida metus id quam rhoncus iaculis. Donec sit amet sodales tellus. Aenean et mauris sapien.

          Good day, buddy - Have you been able to obtain an updated census with the Leviticus occupations?  Has the due date been extended on this RFP?

          Vestibulum faucibus quam id lectus egestas vehicula. Sed porttitor, enim ut ultricies laoreet, diam eros dignissim leo, vitae elementum sapien lectus nec elit. Mauris vel felis vulputate, scelerisque nulla nec, commodo purus. Ut sed mauris sit amet massa placerat eleifend aliquam volutpat nunc. Cras a tincidunt tortor. Integer ullamcorper quis est in porta. Sed ut semper sapien, a aliquam mi. Ut dictum dignissim risus, ut tincidunt quam aliquam id.

          Curabitur et tristique eros. Suspendisse vulputate turpis quam, in gravida nunc varius quis. Proin imperdiet leo eget tellus sagittis, sit amet hendrerit ligula tempus. Curabitur ipsum lectus, tempus sed urna eu, accumsan finibus neque. Suspendisse aliquam eu lectus sed facilisis. Fusce faucibus, sem nec posuere tempus, sapien magna finibus lacus, non venenatis nibh ex tristique ante. Cras sed interdum est, et lobortis enim. Nulla gravida metus id quam rhoncus iaculis. Donec sit amet sodales tellus. Aenean et mauris sapien.

          Good day, buddy - Have you been able to obtain an updated census with the Leviticus occupations?  Has the due date been extended on this RFP?
          `,
        created_at: '2019-10-20T10:01:48.854217',
        id: 500,
        user: carrierUserOne,
        replies: [
          this.getProjectComment({
            content: 'I\'m not your buddy, pal!',
            created_at: '2019-10-20T10:08:48.854217',
            id: 501,
            user: brokerUserOne,
          }),
          this.getProjectComment({
            content: 'I\'m not your pal, guy',
            created_at: '2019-10-20T10:02:48.854217',
            id: 502,
            user: brokerUserTwo,
          }),
          this.getProjectComment({
            content: 'I\'m not your guy, friend',
            created_at: '2019-10-20T10:05:48.854217',
            id: 503,
            user: carrierUserOne,
          }),
          this.getProjectComment({
            content: 'I\'m not your friend, buddy',
            created_at: '2019-10-20T10:10:48.854217',
            id: 504,
            user: brokerUserTwo,
          }),
        ],
      }),
      /* eslint-enable max-len */
    ];

    return comments;
  },
};
